import { createAction } from '@reduxjs/toolkit';

export const bookOfferRequest = createAction('booking/bookOfferRequest');
export const bookOfferSuccess = createAction('booking/bookOfferSuccess');
export const bookOfferFailure = createAction('booking/bookOfferFailure');
export const clearBookingData = createAction('booking/clearBookingData');

export const bookOffer = (payload) => ({
  type: bookOfferRequest.type,
  payload
});